<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        <h2> What is an Invoice? </h2>
                    </h2>
                   
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a></div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='36'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="37">


                    <label for="" class="mt-2"> An invoice is a formal document sent
                        from a merchant
                        to
                        a
                        customer, requesting payment for products or services provided. It is an
                        essential
                        tool
                        in the world of e-commerce, serving several vital functions. </label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="38">
                    <h2>Functions of Invoice </h2>
                    <ul>
                        <li class="mt-3"><b>Record Keeping: </b>&nbsp Invoices provide a clear
                            record of
                            all
                            transactions, ensuring both parties have a detailed account of the
                            products
                            or
                            services exchanged. </li>

                        <li class="mt-3"><b>Payment Request : </b>&nbsp;Invoices serve as a polite
                            yet
                            firm
                            request for payment. They communicate the amount due, payment terms, and
                            the
                            payment
                            methods accepted.</li>


                        <li class="mt-3"><b>Professionalism: </b>&nbsp;Professional, well-designed
                            invoices
                            convey trust and credibility to your customers, enhancing your brand
                            image.
                        </li>


                        <li class="mt-3"><b>Legal Protection: </b>&nbsp;Invoices can serve as legal
                            documentation in case of disputes or audits, offering protection to both
                            merchants
                            and customers. </li>

                    </ul>
            
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="39">
                    <h2>Why Use Invoices with PayG? </h2>
                    <label for="" class="mt-3">When you integrate invoices into your
                        payment process
                        through
                        PayG, you unlock a range of benefits that can significantly improve your
                        payment
                        management: </label>
                   
                    <ul>
                        <li class="mt-3">
                            Efficiency: With PayG's invoicing feature, you can create, send, and
                            track
                            invoices
                            effortlessly. Say goodbye to manual invoice preparation and tracking;
                            our
                            system
                            automates it all for you.
                        </li>
                        <li class="mt-3">
                            Customization: Tailor your invoices to match your brand's identity. Add
                            your
                            logo,
                            choose colors, and use your preferred invoice template.
                        </li>
                        <li class="mt-3">
                            Payment Options: Offer multiple payment methods to your customers,
                            making it
                            easier
                            for them to settle their bills. With PayG, you can accept credit cards,
                            digital
                            wallets, and more.
                        </li>

                        <li class="mt-3">
                            Automated Reminders: Never worry about late payments again. PayG can
                            send
                            automated
                            payment reminders to your customers, reducing late payments and
                            improving
                            cash
                            flow.
                        </li>

                        <li class="mt-3">
                            Detailed Reporting: Access comprehensive reports on your invoicing
                            activity,
                            helping
                            you gain insights into your business's financial health.
                        </li>


                    </ul>
                
                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
                    (mouseout)="showpayment(false,'5')" id="40">
                    <h2>Getting Started with Invoices on PayG </h2>

                    <h5 class="mt-3">
                        Login to Your PayG merchant Account.
                    </h5>
                  
                    <label for="" class="mt-1"> If you haven't already, log in to
                        your PayG merchant
                        account.
                    </label><br>
                  
                    <img src="./assets/Invoice1.png" alt="" width="100%" height="30%" class="mt-2">

                    <h5 class="mt-3">
                        Access Invoicing
                    </h5>
                  
                    <label for="" class="mt-1"> Navigate to the invoicing section
                        within your
                        account
                        dashboard.
                    </label><br>
                   
                    <img src="./assets/Invoice2.png" alt="" width="100%" height="10%" class="mt-2">
                    <h5 class="mt-3">
                        Create an Invoice
                    </h5>
                   
                    <label for="" class="mt-1"> Follow our user-friendly interface
                        to create a new
                        invoice.
                        Fill
                        in the necessary details, including the customer's information, product or
                        service
                        descriptions, prices, and due dates. </label><br>
                   
                    <img src="./assets/Invoice3.png" alt="" width="100%" height="30%" class="mt-2">


                    <h5 class="mt-3">
                        Send the Invoice
                    </h5>
                    
                    <label for="" class="mt-1"> Once your invoice is ready, simply
                        hit the "Send"
                        button.
                        PayG
                        will deliver it to your customer's email address. </label><br>
                  
                    <img src="./assets/Invoice4.png" alt="" width="80%" height="20%" class="mt-2">

                    <h5 class="mt-3">
                        Track and Receive Payments
                    </h5>
                   
                    <label for="" class="mt-1">Monitor the status of your invoices
                        in real-time.
                        Receive
                        payments securely through PayG's payment processing solutions. </label><br>
                  
                    <img src="./assets/Invoice5.png" alt="" width="100%" height="10%" class="mt-2">
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                   
                </div>
                <!-- <div class="col-md-12 mt-2">
                   <a href="#36">  <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Invoice </span>
                        </div>
                    </div><a?
                </div> -->

                <div class="col-md-12 mt-2">
                    <a href="#37">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                   >
                                    Introduction to Invoice </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#38">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                   >Functions
                                    of
                                    Invoice </span>
                              </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#39">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                   >
                                    Why Use Invoices with PayG? </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#40">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                   >Creating
                                    Invoices </span>
                              
                            </div>
                        </div>
                    </a>
                </div>



            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/payment-qr']">  <button class="btn btn-color" (click)="menues('Payment QR')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Payment QR
                </button></a>

            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/video-kyc']">    <button class="btn btn-color" (click)="menues('Video KYC')" >Video
                    KYC
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button>
               </a>
            </div>
        </div>
    </div>
</div>